import styled from 'styled-components';

export const VideoContainer = styled.div`
  position: relative;
  width: 100vw;
  height:  ${
    window.screen.width <= 1000 
    ? 'calc(var(--vh, 1vh) * 100)' 
    // : window.screen.width >= 500 && window.screen.width <= 1025
    // ? 'calc(var(--vh, 1vh) * 40)'
    : 'calc(var(--vh, 1vh) * 85)'
  };
  overflow: hidden;
`;

export const BgVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
`;

export const Overlay = styled.div`
  height: 60%;
  width: ${
    window.screen.width <= 1000 
    ? 'calc(var(--vw, 1vw) * 80)' 
    // : window.screen.width >= 500 && window.screen.width <= 1025
    // ? 'calc(var(--vw, 1vw) * 95)'
    : 'calc(var(--vw, 1vw) * 85)'
  };
  position: absolute;
  top: ${
    window.screen.width <= 1000 
    ? '55%' 
    // : window.screen.width >= 500 && window.screen.width <= 1025
    // ? '60%'
    : '65%'
  };
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.05); /* Dark overlay */
  // color: #fff;
  // margin-top: 7%;
  padding: 20px;
  // border-radius: 10px;
  // text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h1 {
    text-shadow: rgba(0,0,0,0.7) 0px 0px 5px;
    // background-color: rgba(0,0,0,0.02);
    // text-shadow: rgba(128,103,50, 0.5) 0px 0px 5px;
    font-size: ${window.screen.width <= 1000 
      ? 'clamp(2.5rem, 2vw, 2.7rem)'
      // : window.screen.width >= 500 && window.screen.width <= 1025
      // ? 'clamp(2rem, 2vw, 3.7rem)'
      : 'clamp(3.7rem, 2vw, 4.7rem)'
    };
    margin: 0;
  }

  .buttext-container {
    display: flex;
    flex-direction: ${window.screen.width <= 1000 ? 'column' : 'row'};
    justify-content: space-between;
  }

  .buttext-box {
    display: flex;
    flex-direction: column;
    align-items: ${window.screen.width <= 1000 ? 'center' : 'flex-start'};

    p {
      // font-size: ${window.screen.width <= 1025 ? '1.2rem' : '1.4rem'};
      font-size: ${
        window.screen.width <= 1000 
        ? '1.2rem' 
        // : window.screen.width >= 500 && window.screen.width <= 1025
        // ? '1rem'
        : 'clamp(1.2rem, 3vw, 1.5rem)'
      };
      align-self: flex-start;
      line-height: 140%;
    }
  }

`;